<template>
    <div>
        <!-- desabilitado desde 16/09/2019 -->
        <div class="info__out" v-if="showBannerAffiliate">
            <div class="info" ref="modal">
                <span v-html="this.daysLeft"></span>
                <div class="close__modal" @click="closeAlertAffiliate">X</div>
            </div>
        </div>

        <!-- POPUP -->

        <div
            class="modal fade local_modal"
            role="dialog"
            v-for="(item, index) in modalBanners"
            :key="`modal${index}`"
            :ref="`modal${index}`"
        >
            <div class="modal-dialog modal-lg" role="document" >
                <div class="modal-content" :style="{ background: item.banner_info.colorBackground, border: item.banner_info.border }">
                    <div class="body-content">
                        <img :src="`/internacional/public/office5/img/info-general/${item.banner_info.img}.svg`" alt="">
                        <div
                            class="modal-body"
                            :style="{ color: item.banner_info.colorFont }"
                        >
                            <h3 v-html="item.banner_info.title" class="title-modal-body"></h3>
                            <h4 v-html="item.banner_info.subject" class="subject-modal-body"></h4>
                            <div v-html="item.banner_info.description" class="description-modal-body"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                       <span
                           @click="dispatchModalClose()"
                           :style="{ color: item.banner_info.colorFont }"
                       ><img :src="`/internacional/public/office5/img/info-general/close.svg`" alt=""></span>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="info__out"
            v-for="(item, index) in alertBanners"
            :key="`alert${index}`"
            :ref="`alert${index}`"
        >
            <div class="info" ref="modal" :style="{ background: item.banner_info.colorBackground, border: item.banner_info.border }">
                <div class="body_info">
                    <img :src="`/internacional/public/office5/img/info-general/${item.banner_info.img}.svg`" alt="">
                    <span v-html="item.banner_info.description" :style="{ color: item.banner_info.colorFont }"></span>
                </div>
                <div class="close__modal" @click="closeAlertInfo(index, item)" :style="{ color: item.banner_info.colorFont }">X</div>
            </div>
        </div>



        <div class="info__out" v-if="showStorageBanner">
            <div :class="infoStorageGeneral.type" ref="modal">
                <div class="body_info">
                    <img :src="`/internacional/public/office5/img/info-general/${img}.svg`" alt="">
                    <span v-html="infoStorageGeneral.text" class="text__click" @click="buyExtraStorage"></span>
                </div>
                <div class="close__modal" @click="closeAlertStorage" :style="{ color: colorFont }">X</div>
            </div>
        </div>

        <div class="info__out" v-if="showEarnsBanner">
            <div class="info" ref="modal" :style="{ background: colorBackground, border: border }">
                <div class="body_info">
                    <img :src="`/internacional/public/office5/img/info-general/${img}.svg`" alt="">
                    <span v-html="view.banner_earns.text" :style="{ color: colorFont }"></span>
                </div>
                <div class="close__modal" @click="closeAlertEarns" :style="{ color: colorFont }">X</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "new-info-modal",
    props: ["view"],
    data() {
        return {
            showBannerGeneral: false, // sem uso
            infosBannerGeneral: null, // sem uso
            localStorageClosed: false, // sem uso

            showBannerAffiliate: false,
            daysLeft: null,
            showStorageBanner: false,
            infoStorageGeneral: null,
            colorBanner: '#ffc400', /* banner earns */
            // colorFont: '#5b5b5b', /* banner earns */
            title: 'Title',
            colorBackground : '#f5ecdb',
            border: '3px solid #f8cd7a',
            colorFont: 'rgb(255 167 0)',
            img: 'info_general_alert',

            alertBanners: [],
            modalBanners: [],

            showEarnsBanner: false
        }
    },
    methods: {
        closeAlertAffiliate(){
            this.showBannerAffiliate = false;
            this.setLocalStorageItem('affiliate-banner-general-closed', true);
        },
        closeAlertEarns(){
            this.showEarnsBanner = false;
            this.setLocalStorageItem('earns-banner-general-closed', true);
        },
        closeAlertStorage(){
            this.showStorageBanner = false;
            this.setLocalStorageItem('storage-banner-general-closed', true);
        },
        closeAlertInfo(index, item) {
            // console.log('====================================');
            // console.log(item, this.allBanners);
            // console.log('====================================');
            this.alertBanners.splice(index, 1);
            let closed = this.getLocalStorageItem('info-banner-general-closed');
            if(!closed.includes(item.banner_info.id)) { // nao inserir indice repetido
                closed.push(item.banner_info.id);
            }
            this.setLocalStorageItem('info-banner-general-closed', closed);
            // // console.log('====================================');
            // // console.log(item, this.allBanners);
            // // console.log('====================================');

            // let itemsClosed = sessionStorage.getItem("info-banner-general-closed");
            // // console.log(itemsClosed, itemsClosed.lenght > 0);
            // console.log(itemsClosed);
            // if(itemsClosed.length != null) {

            // }

            // sessionStorage.setItem("info-banner-general-closed", item)
        },
        buyExtraStorage(){
            $('#modalBuyExtraStorage').modal('show');
        },
        contactSponsor(){
            $('#send-message-upline-sponsored').modal('show');
        },
        getModalBanners: function(allBanners) {
            let _this = this;
            return allBanners.filter((el, index, arr) => {
                return ( el.show_banner && el.is_popup && !_this.getLocalStorageItem('info-banner-general-closed').includes(el.banner_info.id));
            }).map(this.setModalColor);
        },
        getAlertBanners: function(allBanners) {
            let _this = this;
            return allBanners.filter((el, index, arr) => {
                return ( el.show_banner && !el.is_popup && !_this.getLocalStorageItem('info-banner-general-closed').includes(el.banner_info.id));
            }).map(this.setModalColor);
        },
        setModalColor(modal, i, arr){
            switch(modal.banner_info.color) {
                case 'y':
                    modal.banner_info.colorBackground = '#fff6e5';
                    modal.banner_info.border = '3px solid #f8cd7a';
                    modal.banner_info.colorFont = '#FCA500';
                    modal.banner_info.img = 'info_general_alert';
                    break;
                case 'r':
                    modal.banner_info.colorBackground = '#fdece7';
                    modal.banner_info.border = '3px solid #ef5021';
                    modal.banner_info.colorFont = '#EF4411';
                    modal.banner_info.img = 'info_general_error';
                    break;
                case 'g':
                    modal.banner_info.colorBackground = '#ecfde7';
                    modal.banner_info.border = '3px solid #86e969';
                    modal.banner_info.colorFont = '#43E313';
                    modal.banner_info.img = 'info_general_confirm';
                    break;
                case 'b':
                    modal.banner_info.colorBackground = '#e4f2ff';
                    modal.banner_info.border = '3px solid #97c8f7';
                    modal.banner_info.colorFont = '#0080FC';
                    modal.banner_info.img = 'backoffice';
                    break;
                case 'u':
                    modal.banner_info.colorBackground = '#ededed';
                    modal.banner_info.border = '3px solid #c7c7c7';
                    modal.banner_info.colorFont = '#6f6f6f';
                    modal.banner_info.img = 'backoffice';
                    break;
            }
            return modal
        },
        /* LOCAL STORAGE */
        setLocalStorageItem(key, data){
            let localStorage = window.localStorage;
            localStorage.setItem(key, JSON.stringify(data));
        },
        getLocalStorageItem(key){
            let localStorage = window.localStorage;
            let data = localStorage.getItem(key);
            return null !== data ? JSON.parse(data) : null;
        },
        initializeLocalStorage(){
            let localStorage = window.localStorage;
            if( null === localStorage.getItem('info-banner-general-closed') ){
                this.setLocalStorageItem('info-banner-general-closed', []);
            }

            if( null === localStorage.getItem('affiliate-banner-general-closed') ){
                this.setLocalStorageItem('affiliate-banner-general-closed', false);
            }

            if( null === localStorage.getItem('earns-banner-general-closed') ){
                this.setLocalStorageItem('earns-banner-general-closed', false);
            }

            if( null === localStorage.getItem('storage-banner-general-closed') ){
                this.setLocalStorageItem('storage-banner-general-closed', false);
            }
        },
        refreshLocalStorage(){
            this.initializeLocalStorage();

            /* remove elementos que estao no local storage
            e ja nao estao mais vindo do php (modais que expiraram) */
            let closedBanners = this.getLocalStorageItem('info-banner-general-closed');

            let banner_info = this.view.banner_info || [] /* this.view.banner_info pode ser null */

            let ids = banner_info.map((el, index, arr) => { return el.banner_info.id } )

            let itens2Remove = closedBanners.filter((el, index, arr) => !ids.includes(el) )

            for(let i = 0; i < itens2Remove.length; i++) {
                let index = -1
                if( ( index = closedBanners.indexOf(itens2Remove[i])) != -1 ) {

                    closedBanners.splice(index, 1)
                }
            }

            this.setLocalStorageItem('info-banner-general-closed', closedBanners)
        },
        /* MODAL */
        openFirstModal() {
            if(this.modalBanners.length > 0 && $('.alert__trial__expired').length == 0){
                let _this = this
                $(document).ready(function(){
                    $(_this.$refs.modal0).modal({ backdrop: 'static', keyboard: false })
                    $(_this.$refs.modal0).on('hidden.bs.modal', function(){
                        _this.closeModalInfo()
                    })
                })
            }
        },
        closeModalInfo() {
            if(this.modalBanners.length > 0){
                let index = 0
                let item = this.modalBanners[index]

                this.modalBanners.splice(index, 1);
                let closed = this.getLocalStorageItem('info-banner-general-closed')
                if(!closed.includes(item.banner_info.id)) { // nao inserir indice repetido
                    closed.push(item.banner_info.id)
                }
                this.setLocalStorageItem('info-banner-general-closed', closed)

                this.openFirstModal()
            }
        },
        dispatchModalClose(){
            let _this = this
            $(document).ready(function(){
                $(_this.$refs.modal0).modal('hide')
            })
        }
    },
    created() {
        console.log('VIEW -> ',this.view);
        if (this.view !== undefined && this.view !== null) { /* precisa ter pelo menos 1 modal definido */
            this.refreshLocalStorage()
            // <LIMIT BANNER>
            //send to vue way the info
            this.showBannerAffiliate = this.view.banner_affiliate_info.infos.isAffiliateTrial && !this.getLocalStorageItem('affiliate-banner-general-closed');
            this.daysLeft = this.view.banner_affiliate_info.label_days_left;

            //Storage limits banner
            this.showStorageBanner  = this.view.banner_storage.show && !this.getLocalStorageItem('storage-banner-general-closed')
            this.infoStorageGeneral = this.view.banner_storage.info
            this.showEarnsBanner = this.view.banner_earns.show && !this.getLocalStorageItem('earns-banner-general-closed');
            // </LIMIT BANNER>

            // console.log('====================================');
            // console.log(this.view.banner_info);
            // console.log('====================================');
            // //get the storaged item
            // this.localStorageClosed = sessionStorage.getItem("info-banner-general-closed");

            // //if the user didnt closed before will show
            // if(!this.localStorageClosed) {
            //     //send to vue way the info
            //     this.showBannerGeneral = this.view.banner_info.show_banner;
            //     this.infosBannerGeneral = this.view.banner_info.banner_info;
            // }


            // if(this.infosBannerGeneral.color == 'y') this.colorBanner = '#ffc400';
            // if(this.infosBannerGeneral.color == 'r') this.colorBanner = '#FF6854';
            // if(this.infosBannerGeneral.color == 'g') {
            //     this.colorBanner = '#27AE60';
            //     this.colorFont = 'white';
            // }
            // if(this.infosBannerGeneral.color == 'b') {
            //     this.colorBanner = '#333333';
            //     this.colorFont = 'white';
            // }
            // console.log(this.infosBannerGeneral);
            this.alertBanners = this.getAlertBanners(this.view.banner_info || [])/* this.view.banner_info pode ser null */
            this.modalBanners = this.getModalBanners(this.view.banner_info || [])/* this.view.banner_info pode ser null */

            // this.allBanners = this.view.banner_info;
            // let itemsToShow = this.view.banner_info || [];
            // let vm = this;
            // itemsToShow.map((el, i) => {
            //     if(el.show_banner) {
            //         if(el.banner_info.color == 'y') vm.allBanners[i].banner_info.colorBackground = '#ffc400';
            //         if(el.banner_info.color == 'r') vm.allBanners[i].banner_info.colorBackground = '#FF6854';
            //         if(el.banner_info.color == 'g') {
            //             vm.allBanners[i].banner_info.colorBackground = '#27AE60';
            //             vm.allBanners[i].banner_info.colorFont = 'white';
            //         }
            //         if(el.banner_info.color == 'b') {
            //             vm.allBanners[i].banner_info.colorBackground = '#333333';
            //             vm.allBanners[i].banner_info.colorFont = 'white';
            //         }
            //     }
            // });
            // console.log('====================================');
            // console.log(this.allBanners);
            // console.log('====================================');
            this.openFirstModal()
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../../../scss/office";
.info__out {
    position: relative;
    .info {
        // background: $secondary-color-7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: 5px;
        padding: 0.4rem 1rem .4rem .5rem;
        margin: .1%;
        transition: .5s all ease;
        width: 99.8%;
        border-radius: 3px;
        .body_info{
            display: flex;
            align-items: center;
            img {
                width: 1.82vw; //30%;
                height: 1.82vw;
            }
            span {
                padding-left: 1rem;
                display: block;
                font-weight: 600;
                margin-top: 9px;
            }
        }
        .close__modal {
            font-weight: 600;
            cursor: pointer;
        }
    }
    .text__click{
        cursor: pointer;
    }
    .limit__storage {
        background: $secondary-color-2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.4rem 1rem;
        transition: .5s all ease;
        width: 100%;
        span {
            display: block;
            color: #ffffff;
            font-weight: 600;
            p{
                margin: 0 !important;
            }
        }
        .close__modal {
            font-weight: 600;
            color: #ffffff;
            cursor: pointer;
        }
    }
}
.local_modal{
    font-weight: 600!important;
    .modal-content{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .body-content{
            display: flex;
            align-items: center;
            padding-left: 1%;
            .title-modal-body{
                font-size: 2em;
            }
            .subject-modal-body{
                font-size: 1.15em;
            }
            .description-modal-body{
                margin-top: 1em;
                /deep/ .ql-align-center{
                    text-align: center;
                }
                /deep/ .ql-align-right{
                    text-align: right;
                }
                /deep/ .ql-align-left{
                    text-align: left;
                }
            }
            img {
                height: 39px;
            }
        }
        .modal-footer{
            text-align: right;
            span{
                &:hover{
                    cursor: pointer;
                }
            }
        }
    }
}

@media screen and (max-width: 991px) {
    .modal-content{
        flex-direction: column-reverse !important;
        justify-content: right !important;
        align-items: normal !important;
        .body-content{
            flex-direction: column;
            .modal-body{
                padding: 10px 20px;
            }
        }
    }
}   
@media screen and (max-width: 650px) {
    .modal-content{
        .body-content{
            .modal-body{
                width: 100%;
                .description-modal-body {
                    /deep/ .ql-video{
                        width: 100% !important;
                    }
                }
            }
        }
    }
}  
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/info-modal/NewInfoModal.vue